import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Column } from 'primereact/column';
import { TreeTable, TreeTableSelectionEvent, TreeTableSelectionKeysType } from 'primereact/treetable';
import { TreeNode } from 'primereact/treenode';
import { HttpStatusCode } from '../../../shared/request/HttpStatusCode';
import Request from '../../../shared/request/Request';
import { API } from '../../../shared/constants/API';
import ToasterHelper from '../../../shared/helpers/toaster.helper';
import TreeNodeHelper from '../../../shared/helpers/tree-node.helper';

interface InterestsTreeTableProps {
  selectedNodeKeys: TreeTableSelectionKeysType | string;
  onSelectionChange: (keys: TreeTableSelectionKeysType | string) => void;
  initialNodes?: TreeNode[];
}

const InterestsTreeTable = ({ selectedNodeKeys, onSelectionChange, initialNodes }: InterestsTreeTableProps) => {
  const { t } = useTranslation();
  const [nodes, setNodes] = useState<TreeNode[]>([]);
  const [nodesLoaded, setNodesLoaded] = useState(false);

  useEffect(() => {
    if (initialNodes) {
      setNodes(initialNodes);
      setNodesLoaded(true);
    } else if (!nodesLoaded) {
      Request.get(`${API.BACK_OFFICE_SERVICE}/getInterests`, {})
        .then((response: any) => {
          if (response.status.toString() === HttpStatusCode.OK) {
            setNodesLoaded(true);
            setNodes(TreeNodeHelper.mapNodes(response.body.result));
          } else {
            if (response.status.toString() === HttpStatusCode.TOO_MANY_REQUESTS) {
              ToasterHelper.notify(t('ERRORS.TRY_AGAIN_LATER'), 'info');
            }
          }
        })
        .catch(error => {
          ToasterHelper.notify(t('ERRORS.AN_ERROR_OCCURRED'), 'error');
          console.log(error);
        });
    }
  }, [initialNodes, nodesLoaded, t]);

  const handleSelectionChange = (e: TreeTableSelectionEvent) => {
    onSelectionChange(e.value);
  };

  return (
    <div className='col-md-12 flex text-sm margin-before-20px'>
      <TreeTable
        value={nodes}
        selectionMode='checkbox'
        selectionKeys={selectedNodeKeys}
        onSelectionChange={handleSelectionChange}
        tableStyle={{ minWidth: '50rem' }}>
        <Column field='label' header='Name' expander></Column>
        <Column field='active' header='Is Active'></Column>
      </TreeTable>
    </div>
  );
};

export default InterestsTreeTable;
